// extracted by mini-css-extract-plugin
export var component = "ErrorMessage-module--component--f4z0A";
export var error = "ErrorMessage-module--error--H9kvQ";
export var icon = "ErrorMessage-module--icon--lrvoU";
export var info = "ErrorMessage-module--info--Cs3+S";
export var textError = "ErrorMessage-module--textError--KgyHl";
export var textInfo = "ErrorMessage-module--textInfo--gOJj8";
export var textWarning = "ErrorMessage-module--textWarning--0K+el";
export var warning = "ErrorMessage-module--warning--zNrRi";